export default "__VITE_ASSET__eWGSz49I__"